import { watchDeleteSalesAdminObject } from './deleteSaObject';
import { watchFetchSalesDistrictGoals } from './fetchSalesDistrictDealerGoals';
import { watchFetchSaSalesDistricts } from './fetchSalesDistricts';
import { watchSaveNegotiatingTactic } from './saveNegotiatingTactic';
import { watchSaveSaRegion } from './saveRegion';
import { watchSaveSaSalesDistricts } from './saveSalesDistrict';
import { watchSaveSalesDistrictDealerGoal } from './saveSalesDistrictDealerGoal';
import { watchSaveSourceOfPower } from './saveSourceOfPower';
import { watchUpdateSaObject } from './updateSaObject';

export const adminSalesSagas = [
  watchDeleteSalesAdminObject(),
  watchFetchSaSalesDistricts(),
  watchFetchSalesDistrictGoals(),
  watchSaveNegotiatingTactic(),
  watchSaveSaRegion(),
  watchSaveSaSalesDistricts(),
  watchSaveSalesDistrictDealerGoal(),
  watchSaveSourceOfPower(),
  watchUpdateSaObject()
];
